import React from 'react';
import { Stack, TableCell, Typography } from '../library';
import { MultiValue } from '../index';

const Literal = props => {
    const { text, property, decorator, children, color, ...rest } = props;

    if (Array.isArray(text)) {
        return (
            <MultiValue
                values={text}
                property={property}
                type='Text'
                color={color}
            >
                {children && children}
            </MultiValue>
        );
    }

    return (
        <Stack
            sx={{ color: color }}
            direction='row'
            alignItems='center'
            spacing={1}
        >
            {(!decorator || decorator === 'start') && children}
            <Typography {...rest}>{text}</Typography>
            {decorator && decorator === 'end' && children}
        </Stack>
    );
};

export default Literal;
